var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2E373",
    d: "M12 18.857a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 0 0 0 13.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLuna0)",
    d: "M14.143 3.429c-.575.857-1.685 1.453-2.452 1.718a6.857 6.857 0 0 0-6.463 7.937c.617 1.886 1.899 3.172 3.665 3.27c1.842.108 3.638-.552 4.478-2.58c.677-1.628 1.869-2.104 2.379-2.202h3.964l-.964-.686c-1.427-1.222-3.635-1.084-4.217-.579a3.17 3.17 0 0 1-1.792.755c-2.19 0-2.383-1.659-2.383-2.049V8.97c-.004-.446-.013-1.727 2.045-2.417a2.65 2.65 0 0 0 1.517-1.14h-.005c.438-.677.343-1.629.228-1.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLuna1)",
    d: "M17.605 15.952a6.857 6.857 0 0 1-12.351-2.73c.416 1.217 1.65 3.175 3.951 3.132c2.499-.042 3.738-1.602 4.072-2.468c.338-.857 1.178-2.006 2.464-2.314c-.527.325-1.487 1.221-1.388 2.314c.115 1.333 1.191 2.216 3.252 2.066"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLuna0",
    x1: 8.228,
    x2: 16.553,
    y1: 5.913,
    y2: 12.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE3633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLuna1",
    x1: 9.591,
    x2: 12.021,
    y1: 14.648,
    y2: 18.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E04437"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.bb7409c15589bfa1a940f0d62898f10e.svg";
export { ForwardRef as ReactComponent };